import { Grid } from "@mui/material";
import Blog from "components/local/dashboard/blog";
import Vacancy from "components/local/dashboard/vacany";
import SideBar from "components/UI/SideBar/SideBar";
import React from "react";

const BlogPage = () => {
  return (
    <Grid container sx={{ backgroundColor: "#F5F5F5" }}>
      <Grid item md={2}>
        <SideBar />
      </Grid>
      <Grid
        item
        md={10}
        sm={6}
        xs={12}
        sx={{ marginInline: { sm: "auto", md: "initial" } }}
      >
        <Blog />
      </Grid>
    </Grid>
  );
};

export default BlogPage;
